module.exports = __webpack_public_path__ + "img/img_aboutus_goal_students@2x.3cbb1c4a.png";